import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const ref = params.get("reference") || params.get("trxref");
  const [state, setState] = useState("verifying");

  useEffect(() => {
    if (!ref) { setState("failed"); return; }
    api.get(`/sponsor/payments/verify/${ref}`)
      .then((r) => setState(r.data.status === "paid" ? "success" : "failed"))
      .catch(() => setState("failed"));
  }, [ref]);

  return (
    <div className="min-h-screen bg-emerald-950 tmf-grain flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 text-center shadow-2xl">
        {state === "verifying" && <><Loader2 className="w-10 h-10 animate-spin text-emerald-600 mx-auto" /><h1 className="mt-5 font-display font-bold text-xl text-emerald-950">Verifying your payment…</h1></>}
        {state === "success" && <><CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto" /><h1 className="mt-5 font-display font-bold text-2xl text-emerald-950">Payment Successful</h1><p className="mt-2 text-sm text-gray-600">Reference {ref}</p></>}
        {state === "failed" && <><XCircle className="w-12 h-12 text-red-500 mx-auto" /><h1 className="mt-5 font-display font-bold text-2xl text-emerald-950">Payment Not Confirmed</h1><p className="mt-2 text-sm text-gray-600">If you were debited, contact support with reference {ref || "—"}.</p></>}
        <Button data-testid="payment-back-btn" onClick={() => navigate("/sponsor")} className="mt-7 w-full h-12 bg-emerald-600 hover:bg-emerald-700 rounded-full">Back to Dashboard</Button>
      </div>
    </div>
  );
}
